const characters = [
  {
    id: "tristan",
    name: "Tristan",
  },
  {
    id: "skuld",
    name: "Skuld",
  },
  {
    id: "mael",
    name: "Mael",
  },
  {
    id: "lancelot",
    name: "Lancelot",
  },
  {
    id: "kiane",
    name: "Kiane",
  },
  {
    id: "elimeli",
    name: "EliMeli",
  },
  {
    id: "dk",
    name: "Demon King",
  },
  {
    id: "cusack",
    name: "Cusack",
  },
  {
    id: "gelda",
    name: "Gelda",
  },
  {
    id: "sigurd",
    name: "Sigurd",
  },
  {
    id: "ban_l",
    name: "Light Ban",
  },
  {
    id: "sariel",
    name: "Sariel",
  },
  {
    id: "ban_lr",
    name: "LR Ban",
  },
  {
    id: "brunhild",
    name: "Brunhild",
  },
  {
    id: "chandler",
    name: "Chandler",
  },
  {
    id: "diane_lr",
    name: "LR Diane",
  },
  {
    id: "diane_rag",
    name: "Ragnarok Diane",
  },
  {
    id: "estarossa",
    name: "Estarossa",
  },
  {
    id: "freyr",
    name: "Freyr",
  },
  {
    id: "hel",
    name: "Hel",
  },
  {
    id: "helbram",
    name: "Helbram",
  },
  {
    id: "meli_berserk",
    name: "Meliodas",
  },
  {
    id: "merlin",
    name: "LR Merlin",
  },
  {
    id: "nanashi",
    name: "Nanashi",
  },
  {
    id: "nasiens",
    name: "Nasiens",
  },
  {
    id: "pellegarde",
    name: "Pellegarde",
  },
  {
    id: "percival",
    name: "Percival",
  },
  {
    id: "skadi",
    name: "Skadi",
  },
  {
    id: "tarmiel",
    name: "Tarmiel",
  },
  {
    id: "arthur",
    name: "Arthur Chaos",
  },
  {
    id: "camila",
    name: "Camila",
  },
  {
    id: "escanor",
    name: "UR Escanor",
  },
  {
    id: "gowther",
    name: "UR Gowther",
  },
  {
    id: "matrona",
    name: "Matrona",
  },
];

export default characters;